import { render, staticRenderFns } from "./SweetModal.vue?vue&type=template&id=7c13b54d&scoped=true&"
import script from "./SweetModal.vue?vue&type=script&lang=js&"
export * from "./SweetModal.vue?vue&type=script&lang=js&"
import style0 from "./SweetModal.vue?vue&type=style&index=0&id=7c13b54d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c13b54d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\sweet-modal-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c13b54d')) {
      api.createRecord('7c13b54d', component.options)
    } else {
      api.reload('7c13b54d', component.options)
    }
    module.hot.accept("./SweetModal.vue?vue&type=template&id=7c13b54d&scoped=true&", function () {
      api.rerender('7c13b54d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SweetModal.vue"
export default component.exports